<script lang="ts">
  import { Contabilidad, type CuentaContable, type AsientoContable } from '../lib/api';

  let cuentas = $state<CuentaContable[]>([]);
  let asientos = $state<AsientoContable[]>([]);
  let balance = $state<any | null>(null);
  let er = $state<any | null>(null);
  let error = $state<string | null>(null);

  let nuevaCta = $state<CuentaContable>({ codigo:'', nombre:'', tipo:'ACTIVO', naturaleza:'DEUDORA', nivel:1, permiteMov:true });
  let nuevoAs = $state<AsientoContable>({ fecha: new Date().toISOString().slice(0,10), concepto:'', partidas:[{ cuentaId:'', debe:0, haber:0, descripcion:'' }, { cuentaId:'', debe:0, haber:0, descripcion:'' }] });

  async function cargar() {
    try { cuentas = await Contabilidad.cuentas(); asientos = await Contabilidad.asientos(); }
    catch (e:any) { error = e?.message; }
  }
  async function crearCta(e: SubmitEvent) { e.preventDefault();
    try { await Contabilidad.crearCta({ ...nuevaCta }); nuevaCta = { codigo:'', nombre:'', tipo:'ACTIVO', naturaleza:'DEUDORA', nivel:1, permiteMov:true }; await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function agregarPartida() { nuevoAs.partidas = [...nuevoAs.partidas, { cuentaId:'', debe:0, haber:0, descripcion:'' }]; }
  async function crearAs(e: SubmitEvent) { e.preventDefault();
    try { await Contabilidad.crearAs({ ...nuevoAs }); nuevoAs = { fecha:new Date().toISOString().slice(0,10), concepto:'', partidas:[{ cuentaId:'', debe:0, haber:0, descripcion:'' }, { cuentaId:'', debe:0, haber:0, descripcion:'' }] }; await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function registrar(id: string) { try { await Contabilidad.registrar(id); await cargar(); } catch (e:any) { error = e?.message; } }
  async function verBalance() { try { balance = await Contabilidad.balance(); er = await Contabilidad.estadoResultados(); } catch (e:any) { error = e?.message; } }

  $effect(() => { cargar(); });

  const sumDebe  = $derived(nuevoAs.partidas.reduce((s,p)=>s+Number(p.debe||0),0));
  const sumHaber = $derived(nuevoAs.partidas.reduce((s,p)=>s+Number(p.haber||0),0));
</script>

<section>
  <header><h2>Contabilidad &middot; Partida doble</h2>
    <span><button onclick={verBalance}>Balance / ER</button><button onclick={cargar}>Recargar</button></span>
  </header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  <h3>Catálogo de cuentas</h3>
  <form onsubmit={crearCta} class="row">
    <input placeholder="Código (ej. 1101)" bind:value={nuevaCta.codigo} required style="width:120px"/>
    <input placeholder="Nombre" bind:value={nuevaCta.nombre} required style="flex:1;min-width:200px"/>
    <select bind:value={nuevaCta.tipo}><option>ACTIVO</option><option>PASIVO</option><option>PATRIMONIO</option><option>INGRESO</option><option>GASTO</option><option>COSTO</option><option>ORDEN</option></select>
    <select bind:value={nuevaCta.naturaleza}><option>DEUDORA</option><option>ACREEDORA</option></select>
    <button type="submit">Agregar</button>
  </form>
  <table>
    <thead><tr><th>Código</th><th>Nombre</th><th>Tipo</th><th>Naturaleza</th><th>Saldo</th></tr></thead>
    <tbody>
      {#each cuentas as c (c.id)}<tr><td>{c.codigo}</td><td>{c.nombre}</td><td>{c.tipo}</td><td>{c.naturaleza}</td><td>Q {Number(c.saldoActual ?? 0).toFixed(2)}</td></tr>{:else}<tr><td colspan="5" class="empty">Sin cuentas. Crea el catálogo arriba.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Nuevo asiento</h3>
  <form onsubmit={crearAs}>
    <div class="row">
      <input type="date" bind:value={nuevoAs.fecha} required/>
      <input placeholder="Concepto" bind:value={nuevoAs.concepto} required style="flex:1;min-width:240px"/>
      <button type="button" onclick={agregarPartida}>+ Partida</button>
      <button type="submit" disabled={sumDebe !== sumHaber || sumDebe === 0}>Guardar (Debe Q{sumDebe.toFixed(2)} = Haber Q{sumHaber.toFixed(2)})</button>
    </div>
    <table>
      <thead><tr><th>Cuenta</th><th>Debe</th><th>Haber</th><th>Descripción</th></tr></thead>
      <tbody>
        {#each nuevoAs.partidas as p, idx (idx)}
          <tr>
            <td><select bind:value={p.cuentaId} required><option value="">— cuenta —</option>{#each cuentas as c (c.id)}<option value={c.id}>{c.codigo} {c.nombre}</option>{/each}</select></td>
            <td><input type="number" step="0.01" bind:value={p.debe} style="width:120px"/></td>
            <td><input type="number" step="0.01" bind:value={p.haber} style="width:120px"/></td>
            <td><input bind:value={p.descripcion} style="width:100%"/></td>
          </tr>
        {/each}
      </tbody>
    </table>
  </form>

  <h3>Asientos</h3>
  <table>
    <thead><tr><th>Número</th><th>Fecha</th><th>Concepto</th><th>Estado</th><th>Debe</th><th>Haber</th><th></th></tr></thead>
    <tbody>
      {#each asientos as a (a.id)}<tr>
        <td>{a.numero ?? ''}</td><td>{a.fecha}</td><td>{a.concepto}</td><td>{a.estado}</td>
        <td>Q {Number(a.totalDebe ?? 0).toFixed(2)}</td><td>Q {Number(a.totalHaber ?? 0).toFixed(2)}</td>
        <td>{#if a.estado === 'BORRADOR'}<button onclick={() => registrar(a.id!)}>Registrar</button>{/if}</td>
      </tr>{:else}<tr><td colspan="7" class="empty">No hay asientos contables.</td></tr>{/each}
    </tbody>
  </table>

  {#if balance}
    <h3>Balance general</h3>
    <p>Activo: Q {Number(balance.activo).toFixed(2)} &middot; Pasivo: Q {Number(balance.pasivo).toFixed(2)} &middot; Patrimonio: Q {Number(balance.patrimonio).toFixed(2)} &middot; P+Pat: Q {Number(balance.pasivoMasPatrimonio).toFixed(2)}</p>
  {/if}
  {#if er}
    <h3>Estado de resultados</h3>
    <p>Ingresos: Q {Number(er.ingresos).toFixed(2)} &middot; Costos: Q {Number(er.costos).toFixed(2)} &middot; Gastos: Q {Number(er.gastos).toFixed(2)} &middot; <strong>Utilidad: Q {Number(er.utilidad).toFixed(2)}</strong></p>
  {/if}
</section>

<style>
  header { display:flex; justify-content:space-between; align-items:center }
  .row { display:flex; gap:.5rem; flex-wrap:wrap; margin:.6rem 0; align-items:center }
  .row input, .row select, .row button { padding:.45rem .6rem; border-radius:8px; border:1px solid #ccc; font:inherit }
  .row button { background:#0d6efd; color:#fff; border:0; cursor:pointer }
  .row button[disabled] { background:#aaa; cursor:not-allowed }
  table { width:100%; border-collapse:collapse; margin-bottom:1rem }
  th, td { padding:.5rem .6rem; border-bottom:1px solid #eee; text-align:left; font-size:.9rem }
  td input, td select { padding:.3rem; border-radius:6px; border:1px solid #ccc; font:inherit }
  .err { color:#b00020 } .empty { color:#888; text-align:center; font-style:italic }
  h3 { margin-top:1.5rem }
  td button { padding:.2rem .5rem; font-size:.8rem; border-radius:6px; border:1px solid #ccc; background:#fff; cursor:pointer }
</style>
